<div class="container-fluid text-center" style="max-width: 32% ;margin-bottom: 27%;">
  <h3><b>Change Password</b></h3>
  <div class="row-fluid">
    <div class="span12">
      <div id="sf_admin_container ">
        <div>
          <div *ngIf="passwordNotSecure" class="alert alert-danger" style="font-size: 13px;">
            Your new password doesn't meet the requirements below.
          </div>
          <div *ngIf="error" class="alert alert-danger" style="font-size: 13px;">
            An error occurred while processing your request.
          </div>
          <form [formGroup]="passwordForm" class="form-horizontal">
            <div class="form-group">
              <label class="col-form-label" for="newPassword">New Password</label>
              <div class="col-form-input">
                <input formControlName="newPassword" id="newPassword" pInputText type="password"/>
              </div>
            </div>
            <div class="form-group">
              <label class="col-form-label " for="confirmNewPassword">Confirm new password</label>
              <div class="col-form-input">
                <input formControlName="confirmNewPassword" id="confirmNewPassword" pInputText type="password"/>
              </div>
            </div>
            <app-password-strength (passwordStrength)="passwordValid($event)"
                                   [confirmPasswordToCheck]="passwordForm.value.confirmNewPassword"
                                   [passwordToCheck]="passwordForm.value.newPassword"></app-password-strength>
            <div class="login-form-actions text-center">
              <div>
                <p-button [disabled]="!passwordIsValid" label="Submit" styleClass="btn btn-primary btn-sm text-right"
                          (click)="onSubmit()"></p-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
